import React, { useEffect, useState } from 'react';

import "./FolderTemplates.scss";

import { ReactComponent as FolderOpenImg } from "static/icons/folder-open-templates.svg";
import { ReactComponent as FolderImg } from "static/icons/folder-templates.svg";
import { ReactComponent as ArrowImg } from "static/icons/arrow-gray.svg";
import { ReactComponent as OptionImg } from "static/icons/options.svg";
import { ReactComponent as InfoImg } from "static/icons/info-gray.svg";

import { getTemplateQuickInfo } from "../../utils/builder/IScheduleLogic";
import QuickStatsTemplate from "../template/QuickStatsTemplate";
import OptionMenu from "../template/OptionMenu";
import ModalComponent from "../modals/ModalComponent";
import SaveTemplateModals from "../modals/SaveTemplateModals";
import ProofModal from "../modals/ProofModal";
import { deleteTemplateFromFolder } from "../../store/actions/template";
import { useDispatch, useSelector } from "react-redux";
import { checkPremium, showToast } from "../../utils/helpers";

const FolderTemplates = ({
   folderName,
   templates,
   handleOptionClick,
   activeOption,
   openOptionMenuFolder,
   optionMenuFolder,
   scroll,
   closeOptionMenuFolder,
   setScroll
  }) => {

  useEffect(() => {
    if(scroll) {
      closePopUps();
    }
  }, [scroll]);

  const {
    info: { subscreption },
  } = useSelector((state) => state.user);

  const IS_PREMIUM = checkPremium(subscreption);

  const [isOpenFolder, setOpenFolder] = useState(false);
  const [quickInfo, setQuickInfo] = useState(null);
  const [optionMenu, setOptionMenu] = useState(null);
  const [editTemplate, setEditTemplate] = useState(false);
  const [folderInfo, setFolderInfo] = useState(null);
  const [proofModal, setProofModal] = useState(false);

  const dispatch = useDispatch();

  const openFolder = ()=> setOpenFolder(!isOpenFolder);

  const openQuickInfo = (event, templateName)=> {

    event.stopPropagation();

    if(quickInfo && templateName === quickInfo?.templateName) {
      closeQuickInfo();
    } else {
      closeOptionMenu();
      closeOptionMenuFolder();
      const clientX = event.clientX + 19;
      const clientY = event.clientY - 30;

      getTemplateQuickInfo(templateName,folderName)
        .then((info) => {
          setQuickInfo({clientX, clientY, info, templateName});
          setScroll(false);
        });
    }
  }

  const closeQuickInfo = () => {
    setQuickInfo(null);
  }

  const openOptionMenu = (event, name, folderName) => {

    event.stopPropagation();

    if(optionMenu && name === optionMenu?.templateName) {
      closeOptionMenu();
    } else {
      closeQuickInfo();
      closeOptionMenuFolder();
      const clientX = event.clientX + 19;
      const clientY = event.clientY - 30;

      setOptionMenu({clientX, clientY, templateName: name, folderName: folderName});
      setScroll(false);
    }
  }

  const closeOptionMenu = () => {
    setOptionMenu(null);
  }

  const openEditTemplate = ()=> {
    setFolderInfo(optionMenu);
    closeOptionMenu();
    setEditTemplate(true);
  }

  const closeEditTemplate = ()=> {
    setEditTemplate(false);
  }

  const openProofModal = ()=> {
    setFolderInfo(optionMenu);
    closeOptionMenu();
    setProofModal(true);
  }

  const closeProofModal = () => {
    setProofModal(false);
  };

  const deleteItem = async () => {
    const folderName = folderInfo.folderName;
    const templateName = folderInfo?.templateName;

      try {
        await dispatch(deleteTemplateFromFolder(folderName, templateName));
        showToast(true,"Template was deleted");
      } catch (error) {
        showToast(false, error);
      }

    closeProofModal();
  }

  const closePopUps = () => {
    setQuickInfo(null);
    setOptionMenu(null);
  }

  return (
    <>
      <div className="folder-templates" onClick={openFolder}>
        <div className={`folder-templates__arrow-img 
                        ${isOpenFolder ? 'folder-templates__arrow-img_open' : ""}`}>
          <ArrowImg />
        </div>
        <div className="folder-templates__folder-img">
          {
            isOpenFolder ? <FolderOpenImg /> : <FolderImg />
          }
        </div>
        { folderName }
        <div className={`folder-templates__option-img ${optionMenuFolder?.folderName === folderName && "active-icon"}`}
             onClick={(events) => { openOptionMenuFolder(events, folderName); closePopUps(); }}>
          {
            IS_PREMIUM ? <OptionImg /> : null
          }
        </div>
      </div>

      <div className={`templates ${isOpenFolder ? "templates-open" : ""}`}>
          {
            templates.map((template, index) => {
              return (
                <div key={`${template}-${index}`} className={`template ${activeOption === template ? "template-active" : ""}`}
                     onClick={() => handleOptionClick(template, folderName)}>
                  <div className="template__name">{template}</div>
                  <div className="template__info">
                      <div className={`template__info-img ${quickInfo?.templateName === template && "active-icon"}`}>
                        <InfoImg onClick={(events) => openQuickInfo(events, template, folderName)}/>
                      </div>
                      {
                        IS_PREMIUM &&
                        <div className={`folder-templates__option-img ${optionMenu?.templateName === template && "active-icon"}`}>
                          <OptionImg onClick={(events) => openOptionMenu(events, template, folderName)}/>
                        </div>
                      }
                  </div>
                </div>
              )
            })
          }
        </div>

      <div className={`quick-info ${quickInfo ? "open" : ""}`}style={{top: quickInfo?.clientY, left: quickInfo?.clientX}}>
        {
          quickInfo ? <QuickStatsTemplate quickInfo={quickInfo?.info} closeQuickInfo={closeQuickInfo}/> : null
        }
      </div>

      <div className={`option-menu-wrapper ${optionMenu ? "open" : ""}`} style={{top: optionMenu?.clientY, left: optionMenu?.clientX}}>
        {
          optionMenu ?
            <OptionMenu closeOptionMenu={closeOptionMenu}
                         edit={openEditTemplate}
                         openProofModal={openProofModal}/> : null
        }
      </div>

      <ModalComponent
        onCloseModal={closeEditTemplate}
        isVisible={editTemplate}
      >
        <SaveTemplateModals type={"edit"} closeEditTemplate={closeEditTemplate} folderInfo={folderInfo}/>
      </ModalComponent>
      <ModalComponent
        onCloseModal={closeProofModal}
        isVisible={proofModal}
      >
        <ProofModal proofCallback={deleteItem} cancelButtonText={"Cancel"} proofButtonText={"Yes, delete"}>
          <div>You want to delete <b>“{folderInfo?.templateName}”</b> template?</div>
        </ProofModal>
      </ModalComponent>
    </>
  );
};

export default FolderTemplates;
